export const THEME_KEY = 'theme';
export const MILLISECONDS_FOR_CHANGE = 5000;
